























































import { Component, Vue } from 'vue-property-decorator';
import Event from '@/models/event';
import { debounce } from 'lodash';

@Component
export default class ExportDialog extends Vue {
  public exportDialog: boolean = false;
  public shouldShowCopyMessage: boolean = false;
  public copyMessage: string = '';
  public userName: string = '';

  public created() {
    this.userName = this.$store.state.userName;
    this.updateUserNameStore = debounce(this.updateUserNameStore, 3000);
  }

  public updateUserName(name: string) {
    this.userName = name;
    this.updateUserNameStore(name);
  }

  public updateUserNameStore(name: string): void {
    this.$store.commit('setUserName', name);
  }

  get emailText(): string {
    const userName: string = this.userName || '<YOUR NAME>';
    return this.$store.state.agenda.events.reduce(
      (text: string, event: Event) => text += `\n${event.code}`, `Name: ${userName}\n\nEvents:`);
  }

  get conEmail(): string {
    return this.$store.state.conEmail;
  }

  get mailtoLink(): string {
    if (this.disableEmail) {
      return '#';
    }
    const subject = encodeURI(`${this.$store.state.conName} Registration`);
    const body = encodeURI(this.emailText);
    return `mailto:${this.conEmail}?subject=${subject}&body=${body}`;
  }

  get disableEmail(): boolean {
    return !this.$store.state.conEmail;
  }

  public showCopyTooltip(message: string): void {
    this.copyMessage = message;
    this.shouldShowCopyMessage = true;
    setTimeout(function() {
      // @ts-ignore
      this.shouldShowCopyMessage = false;
    }.bind(this), 5000);
  }

  public copyEmailText(): void {
    const container = this.$refs.emailText;
    this.$copyText(this.emailText, container).then(this.onCopy, this.onFailedCopy);
  }

  public onCopy(): void {
    this.showCopyTooltip('Email text copied to clipboard.');
  }

  public onFailedCopy(): void {
    this.showCopyTooltip('Error, please copy the email text manually.');
  }
}
